<template>
  <div :class="classes" @click="$emit('click', $event)">
    <div v-if="title" class="ml-card-header">
      {{ title }}
    </div>
    <div class="ml-card-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemlistCard',
  emits: ['click'],
  props: {
    title: {
      type: String,
      default: null
    },
    bg_variant: {
      type: String,
      default: null
    }
  },
  computed: {
    classes() {
      const c = ['ml-card'];

      if (this.bg_variant === 'danger') {
        c.unshift('ml-danger');
      }

      return c;
    }
  }
}
</script>

<style scoped>
.ml-danger {
  background-color: #ffaaaa !important;
}

.ml-card {
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  font-family: 'Poppins';
  font-size: 13px;
}

.ml-card-header {
  padding: 16px;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #dee2e6;
  background-color: #f8f9fa;
}

.ml-card-body {
  padding: 16px;
  font-size: 13px;
  color: #333;
}
</style>
